import cn from "classnames";
import React, { ReactNode, useState } from "react";
import {
  DEFAULT_CONTENT_CLASSNAME,
  DEFAULT_TOOLTIP_CLASSNAME,
  POSITION_CLASSNAME,
} from "./constants";

interface Props {
  children: ReactNode;
  content: ReactNode;
  position?: keyof typeof POSITION_CLASSNAME;
}

export const Tooltip: React.FC<Props> = ({
  children,
  content,
  position = "top",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <div className="relative" onMouseLeave={onClose}>
      <div className="cursor-pointer" onMouseEnter={onOpen}>
        {children}
      </div>
      <div
        className={cn(DEFAULT_TOOLTIP_CLASSNAME, POSITION_CLASSNAME[position], {
          "opacity-100 visible": isOpen,
          "opacity-0 invisible": !isOpen,
        })}
      >
        <div className={DEFAULT_CONTENT_CLASSNAME}>{content}</div>
      </div>
    </div>
  );
};
